import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function Objections() {
  const forYou = ['Nunca tocaste piano', 'Pensás que es difícil', 'No entendés teoría musical', 'Querés aprender de forma simple'];
  const notForYou = ['Buscás formación profesional', 'Querés teoría musical avanzada'];
  return <section className="py-10 bg-beige relative overflow-hidden" data-id="element-68">
      <div className="absolute top-0 left-1/2 w-80 h-80 bg-gold/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-69"></div>

      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-70">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-71">
          <FadeIn data-id="element-72">
            <div className="bg-white rounded-xl p-5 border border-navy/5 shadow-sm h-full" data-id="element-73">
              <h3 className="text-lg font-bold text-navy mb-4 flex items-center gap-2" data-id="element-74">
                <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-75" />
                Esto es para vos si…
              </h3>
              <ul className="space-y-2" data-id="element-76">
                {forYou.map((item, index) => <li key={index} className="flex items-center gap-2 text-sm text-navy/80" data-id="element-77">
                    <span className="w-1.5 h-1.5 rounded-full bg-green-500 flex-shrink-0" data-id="element-78"></span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.15} data-id="element-79">
            <div className="bg-white rounded-xl p-5 border border-navy/5 shadow-sm h-full" data-id="element-80">
              <h3 className="text-lg font-bold text-navy mb-4 flex items-center gap-2" data-id="element-81">
                <XCircle className="w-5 h-5 text-red-400" data-id="element-82" />
                Esto NO es para vos si…
              </h3>
              <ul className="space-y-2" data-id="element-83">
                {notForYou.map((item, index) => <li key={index} className="flex items-center gap-2 text-sm text-navy/80" data-id="element-84">
                    <span className="w-1.5 h-1.5 rounded-full bg-red-400 flex-shrink-0" data-id="element-85"></span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}